function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.1547 10.0018C24.1234 9.9549 23.2797 10.8455 23.2797 11.8768V15.9549H22.9047V7.7049C22.9047 6.67365 22.014 5.78302 20.9828 5.8299C19.9515 5.8299 19.1547 6.67365 19.1547 7.65802V15.9549H18.7797V5.87677C18.7797 4.84552 17.889 3.9549 16.8578 4.00177C15.8265 4.00177 15.0297 4.84552 15.0297 5.8299V15.9549H14.6547V7.75177C14.6547 6.72052 13.764 5.8299 12.7328 5.87677C11.7015 5.87677 10.9047 6.72052 10.9047 7.7049V18.7674L9.40466 16.7518C8.79528 15.908 7.62341 15.7205 6.77966 16.3299C5.93591 16.9393 5.74841 18.1111 6.35778 18.9549L12.264 27.0643C12.639 27.6268 13.3422 27.9549 14.0922 27.9549H23.3265C24.3578 27.9549 25.2953 27.2518 25.5297 26.2205L26.7484 20.9705C26.9359 20.3143 26.9828 19.6111 26.9828 18.908V11.8299C27.0297 10.8455 26.1859 10.0018 25.1547 10.0018Z",
  fill: "#D5D7DE"
});

var SvgHand = function SvgHand(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hand.2e073c25.svg";
export { ForwardRef as ReactComponent };